<template>
  <bill-view></bill-view>
</template>

<script>
import BillView from '../components/bill/BillView';
import '@vuepic/vue-datepicker/dist/main.css';


export default {
  name: 'PartnerBill',
  components: {
    BillView
  }
};
</script>

<style scoped>

</style>